import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'de',
        backend: {
            loadPath: '/locales/{{lng}}/translation.json', // Path to the translation files
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], // Language detection order
            caches: ['cookie'], // Cache the detected language in cookies
            convertDetectedLanguage: (lng) => lng.split('-')[0], // Normalize language to generic code
        },
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    })
export default i18n